import Vue from 'vue'
//const url = window.$website.url
const request = Vue.prototype.$axios;
const baseUrl ='/dtv/api/next/dashboard'
export const getList = (params) => request({
  url: baseUrl + '/get/page/by/condition',
  method: 'get',
  params: {cmd:params}
});



export const copyObj = (id) => request({
  url: baseUrl + '/do/copy/by/id',
  method: 'post',
  params: {
    id: id
  }
});

export const getCategory = (params) => request({
  url: baseUrl + '/category/get/all/list',
  method: 'get',
// /  param: {cmd:params}
});

export const getObj = (id) => request({
  url: baseUrl + '/get/by/id',
  method: 'get',
  params: {
    id:id
  }
});

export const getInstance = (id) => request({
  url: baseUrl + '/get/instance/by/id',
  method: 'get',
  params: {
    id:id
  }
});
export const uploadImg = (file) => request({
  url: baseUrl + '/do/upload/resource',
  method: 'post',
  data: file,
  headers: {
    "Content-Type": "multipart/form-data"
  }
});

export const addObj = (data) => request({
  url: baseUrl + '/do/create',
  method: 'post',
  data: data
});

// 新迁接口更改
export const updateComponent = (data) => request({
  // do/update旧
  url: baseUrl + '/do/update/instance',
  method: 'put',
  data: data
});

export const updateObj = (data) => request({
  url: baseUrl + '/do/update',
  method: 'put',
  data: {
    visual: data
  }
});

export const delObj = (id) => request({
  url: baseUrl + '/do/delete/by/ids',
  method: 'delete',
  data: [id]
});